import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Chantier 4.1 : évite d'afficher un nom de structure évoquant des portes ("Portes battantes")
 * quand aucune section n'a de porte réellement configurée — remplacé par un libellé neutre. */
export function structureLabel(templateName, hasAnyDoor) {
  const name = templateName || "Meuble";
  if (!hasAnyDoor && name.toLowerCase().includes("battante")) return "Caisson sur mesure";
  return name;
}
